import { formApi } from '@/core/api/form'

export const {
  useGetFormTemplateQuery,
  useGetActiveFormTemplatesQuery,
  useSearchFormTemplatesQuery,
  useLazySearchFormTemplatesQuery,
  useCreateFormTemplateMutation,
  useUpdateFormTemplateMutation,
  useArchiveFormTemplateMutation,
  useGetFormSubmissionQuery,
  useSearchFormSubmissionsQuery,
  useCreateFormSubmissionMutation,
  useUpdateFormSubmissionMutation,
  useGetPatientFormSubmissionsQuery,
  useGetConsultationFormSubmissionsQuery,
  useGetExpertiseFormSubmissionsQuery,
  useGetFormStatsQuery,
  useLazyExportFormSubmissionsToCSVQuery,
  useMakePdfFillableMutation,
  useDetectFieldsMutation,
  useBurnPdfMutation,
  useGenerateFilledPdfMutation,
  useGetEthicsSubmissionsQuery,
  useRespondToSubmissionMutation,
} = formApi
